<!-- @Todo TT-2340 Mikhail Create common component with markup and use in each banner via slots -->
<!-- @TODO vik waiting for design -->
<header mat-dialog-title>
  <div>
    <h1 class="c-white mb-15">Upgrade with Holdings Tank</h1>
    <span class="fs-big">
      Manage your shares, crypto and other assets seamlessly in one place.
    </span>
  </div>
  <button mat-dialog-close class="btn icon-close"></button>
</header>

<div mat-dialog-content>
  <div class="banner-image"></div>
  <div class="content-wrapper">
    <div class="mb-10">
      <i class="icon mr-10 icon-check ic-primary"></i>
      <span class="text-center fw-600 c-secondary">Daily market values</span>
    </div>
    <div class="mb-10">
      <i class="icon mr-10 icon-check ic-primary"></i>
      <span class="text-center fw-600 c-secondary">Auto calculate CGT</span>
    </div>
    <div class="mb-10">
      <i class="icon mr-10 icon-check ic-primary"></i>
      <span class="text-center fw-600 c-secondary">End of year tax report</span>
    </div>

    <div class="pv-10">
      <b>$6/m</b>
    </div>

    <button class="btn bg-secondary c-white" (click)="openSubscriptionDialog()">Upgrade now</button>
  </div>
</div>
